// extracted by mini-css-extract-plugin
module.exports = {"container":"GetEds_container__MzJsn","panel":"GetEds_panel__EzFBb","textLarge":"GetEds_textLarge__445ql","textSmall":"GetEds_textSmall__5dllh"};